module.exports = __webpack_public_path__ + "static/media/nochange.ad03799f.svg";